// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".setting[data-v-9d4e29b6]{padding:10px 20px;display:flex;gap:10px}.setting div[data-v-9d4e29b6]{display:flex;gap:5px;align-items:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
